export default () => ({
    open: false,
    init() {
        this.$nextTick(() => {
            document.body.classList.remove('no-transition');
        });
    },
});